/**
 * Goal Progress's two number formatters, in a module of their own.
 *
 * They used to live in data.js, which cannot be imported for a formatter
 * alone: its chain reaches an indexedDB call at load time (via hooks/kpi.js),
 * so every consumer that only wanted to print a dollar figure either dragged
 * that in or kept a private copy of the function. data.js still re-exports
 * both names — every existing import of them keeps working.
 */

/** "$1,234" / "42%" / "1,234" — no abbreviation, used for the goal input,
 *  the "of X" caption and the remaining-to-goal line. */
export const formatFull = (value, kind) => {
  const v = Number(value) || 0;
  if (kind === "$") return `$${Math.round(v).toLocaleString()}`;
  if (kind === "%") return `${Math.round(v * 10) / 10}%`;
  return Math.round(v).toLocaleString();
};

/** "$1.2k" — the ring's hero number, abbreviated past 1000 so a big dollar
 *  goal doesn't outgrow the card at small sizes. */
export const formatCompact = (value, kind) => {
  const v = Number(value) || 0;
  const abs = Math.abs(v);
  if (kind === "%") return `${Math.round(v * 10) / 10}%`;
  let body;
  if (abs >= 10000) body = `${(v / 1000).toFixed(0)}k`;
  else if (abs >= 1000) body = `${(v / 1000).toFixed(1)}k`;
  else body = Math.round(v).toLocaleString();
  return kind === "$" ? `$${body}` : body;
};
